module.exports = require('./dist/InfiniteScroll')



//////////////////
// WEBPACK FOOTER
// /app/node_modules/react-infinite-scroller/index.js
// module id = 1044
// module chunks = 0